export function isLeapYear(year: number) {
  return (
    (
      Math.round(year % 4) === 0 &&
      Math.round(year % 100) !== 0
    ) ||
    Math.round(year % 400) === 0
  );
}
